import React from 'react';
import './WhyUs.css';

import whyChooseUs from '../../../constants/whyChooseUs';
import { images } from '../../../constants';
import { Heading } from '../../../components';



const WhyUs = () => {

  return (
    <section className="why-us linear-bg">
      <div className="box-container">

        {/* Section Heading */}
        <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} />

        {/* Main Description */}
        <p>{whyChooseUs.content}</p>

        {/* Main Content Area */}
        <div className="content">

          {/* Why Choose Us Points - Left Side */}
          <ul className="whyUs-section-points one">
            {whyChooseUs.points.slice(0, 3).map((point) => (
              <li key={point.id}>
                <div className='icon'>{point.icon}</div>
                <div className="text">
                  <h5>{point.title}</h5>
                  <p>{point.content}</p>
                </div>
              </li>
            ))}
          </ul>

          {/* Why Choose Us Image */}
          <div className="image">
            <img src={images.WhyUs} alt="Why Us" />
          </div>

          {/* Why Choose Us Points - Right Side */}
          <ul className="whyUs-section-points two">
            {whyChooseUs.points.slice(3).map((point) => (
              <li key={point.id}>
                <div className='icon'>{point.icon}</div>
                <div className="text">
                  <h5>{point.title}</h5>
                  <p>{point.content}</p>
                </div>
              </li>
            ))}
          </ul>

        </div>

      </div>
    </section>
  );
};

export default WhyUs;